import { IOption } from '@gcl/react-core';

export const designModificationActionerOptions: IOption<string>[] = [
  { key: 'TWC', text: 'TWC' },
  { key: 'TWD', text: 'TWD' },
  { key: 'ICE', text: 'ICE' },
  { key: 'REV', text: 'REVIEWER' },
  { key: '-', text: 'No Action' },
  { key: 'Cancelled', text: 'Cancelled' },
];
